<template>
  <div>
      <div class="row g-2">
          <!-- Map -->
          <div class="col-sm-6 pt-1 px-1">
              <div class="h-100 w-100 p-1">
                  <div
                      class="stat-map-container"
                      style="overflow: hidden; height: 15em; position: relative"
                  >
                      <map-container v-if="getWorkAssignmentPointPosition(workAssignment)" ref="map" @onMapChanged="mapReady" :menu-enabled="false" />
                      <div v-else class="relative slide-img-container text-container px-2" style="height: 15em;">
                          <span class="tip-light">{{ $t('common.no_location') }}</span>
                      </div>
                  </div>
              </div>
          </div>
          <!-- Photos -->
          <div class="col-sm-6 px-1 pt-2">
              <Flicking
                  v-if="photos.length > 0"
                  ref="flicking"
                  :options="options"
                  :plugins="plugins"
                  class="pointer text-center"
                  style="height: 15em;"
              >
                  <div
                      v-for="(photo, index) in photos"
                      :key="index"
                      class="relative stat-map-container slide-img-container"
                  >
                      <ImageView
                          ref="image"
                          :url="photo.url"
                          :base64data="photo.src"
                          control-size="sm"
                          @click="openImage(photo)"
                      />
                  </div>
                  <template #viewport>
                      <span class="flicking-arrow-prev"></span>
                      <span class="flicking-arrow-next"></span>
                      <div class="flicking-pagination flicking-pagination-bullets-container" />
                  </template>
              </Flicking>

              <div v-else class="relative stat-map-container slide-img-container text-container px-2" style="height: 15em;">
                  <span class="tip-light">{{ workAssignment.id && workAssignment.id > 0 ? $t('power_stations.no_photos') : $t('work_assignment.photo_hint') }}</span>
              </div>
          </div>
      </div>
      <Transition name="fade">
          <fullscreen-image
              v-if="fullScreenPhotoData"
              :save-disabled="false"
              :largeImages="fullScreenPhotoData"
              :photo-ids="fullScreenPhotoIds"
              :panelIndex="panelIndex"
              @close="closePhoto"/>
      </Transition>
  </div>
</template>

<script>
import {mapHelper} from '../mixins/MapMixin'
import {Pagination} from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/pagination.css";
import "@egjs/vue3-flicking/dist/flicking.css";
import Flicking from "@egjs/vue3-flicking";
import ImageView from "@/components/view/ImageView.vue";
import { Arrow } from "@egjs/flicking-plugins"
import MarkerEditorMap from "../map/MarkerEditorMap.vue";
import MapContainer from "../map/MapContainer.vue";
import {workAssignmentHelper} from "../mixins/WorkAssignmentMixin.js";
import FullscreenImage from "../view/FullscreenImage.vue";

export default {
    name: 'WorkAssignmentMapPhotos',
    components: {FullscreenImage, MapContainer, MarkerEditorMap, Flicking, ImageView},
    mixins: [mapHelper, workAssignmentHelper],
    props: {
        workAssignment: {
            type: Object,
            default: null
        },
        photos: {
            type: Array,
            default: []
        },
    },
    data: function () {
        return {
            plugins: [
                new Arrow(),
                new Pagination({type: 'bullet'})
            ],
            options: {
                preventDefaultOnDrag: true,
                bound: true,
            },
            map: null,
            Z_INDEX: {
                BEHIND: 2,
                INFRONT: 5
            },
            panelIndex: 0,
            fullScreenPhotoData: null,
            fullScreenPhotoIds: []
        }
    },
    watch: {
        'workAssignment.geometry': function () {
            this.hideAssignments()
            this.drawWorkAssignment()
        }
    },
    methods: {
        mapReady(map) {
            this.map = map
            if (this.map && this.workAssignment) {
                this.drawWorkAssignment()
            }
        },

        drawWorkAssignment: function () {
            if (this.workAssignment && this.map) {
                const workAssignment = this.workAssignment
                var pointToZoom = null
                var markerStore = this.map.getMarkerStore()
                let markerPosition = this.getWorkAssignmentPointPosition(workAssignment)
                if (markerPosition != null){
                    let icon = workAssignment.status > this.ASSIGNED ? markerStore.getClosedWorkAssignmentMarkerIcon() : markerStore.getWorkAssignmentMarkerIcon(workAssignment.status === this.OPEN)
                    this.map.showMapMarker(workAssignment.id, this.WORK_ASSIGNMENT, markerPosition.y,
                        markerPosition.x, icon, false, workAssignment.closed_time ? this.Z_INDEX.BEHIND : this.Z_INDEX.INFRONT)
                }
                let geometry = null
                if (workAssignment.observation) {
                    geometry = workAssignment.observation.geometry
                } else if (workAssignment.geometry) {
                    geometry = workAssignment.geometry
                } else if (markerPosition) {
                    geometry = markerPosition
                }
                if (geometry) {
                    let assignmentStrokeColor = '#219ade'
                    if (geometry.polygon) {
                        this.map.drawPolygon(workAssignment.id, geometry.polygon.rings[0], this.WORK_ASSIGNMENT, assignmentStrokeColor, '#219ade', 0.2)
                    }else if (geometry.line_string) {
                        var xyLine = geometry.line_string.points.map(point => {
                            return {x: point[0], y: point[1]}
                        })
                        this.map.drawPolyLine(workAssignment.id, this.WORK_ASSIGNMENT, xyLine, assignmentStrokeColor)
                    }
                    pointToZoom = markerPosition
                    this.map.zoomToPosition(pointToZoom.y, pointToZoom.x)
                }
            }
        },

        hideAssignments: function () {
            if (this.map) {
                this.map.removeMapItemsByType(this.WORK_ASSIGNMENT)
            }
        },

        openImage: function () {
            const flicking = this.$refs.flicking
            const imageData = this.$refs.image
            this.fullScreenPhotoData = []
            this.fullScreenPhotoIds = []

            imageData.forEach((src, index) => {
                this.fullScreenPhotoData.push(src)
                this.fullScreenPhotoIds.push(this.photos[index].id)
            })
            this.panelIndex = flicking.index

        },
        closePhoto() {
            this.fullScreenPhotoData = null
        },

    }
}
</script>

<style scoped>
.map-container {
    height: 250px;
    margin-bottom: -0.2em;
}
.flicking-pagination-bullets-container {
    bottom: .5rem;
}
</style>


